import { createFileRoute } from "@tanstack/react-router"

import { LazyUnifiedDashboard, PageSuspense } from "@/components/lazy"

export const Route = createFileRoute("/_layout/")({
  component: Dashboard,
})

function Dashboard() {
  return (
    <PageSuspense>
      <LazyUnifiedDashboard />
    </PageSuspense>
  )
}
